import styled from 'styled-components';
import Ad from 'components/Ad';

export const BlogSidebarWrapper = styled.div`
  max-width: 310px;
  width: 100%;
  height: 100%;
`;

export const SidebarRecommend = styled.div`
  margin-top: 40px;
  font-family: 'Sofia Pro';

  .blog-sidebar-recommend--title {
    font-family: 'Sofia Pro';
    font-size: 20px;
    line-height: 120%;
    letter-spacing: -0.01em;
  }

  .blog-sidebar-recommend--content {
    margin-top: 8px;

    .blog-sidebar-recommend--content-item {
      display: flex;
      align-items: center;
      padding: 15px 0;
      border-bottom: 1px solid var(--neutral-2);

      .blog-sidebar-recommend--content-item-img {
        width: 75px;
        height: 75px;
        min-width: 75px;
      }

      .blog-sidebar-recommend--content-item-title {
        font-family: 'Sofia Pro';
        font-weight: 500;
        font-size: 16px;
        line-height: 150%;
        color: var(--black-color);
        margin: 0;
        padding: 0;
        margin-left: 20px;
      }

      &:last-child {
        border-bottom: none;
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }

  @media (max-width: 935px) {
    display: none;
  }
`;

export const SidebarOurTools = styled.div`
  background-color: var(--neutral-1);
  width: 100%;
  padding: 24px 28px;
  margin-top: 40px;

  .blog-sidebar-ourtools--title {
    font-family: 'Sofia Pro';
    font-weight: bold;
    font-size: 20px;
    line-height: 120%;
    letter-spacing: -0.01em;
    color: var(--neutral-7);
  }

  .blog-sidebar-ourtools--content {
    display: flex;
    flex-direction: column;

    .blog-sidebar-ourtools--content-item {
      font-family: 'Sofia Pro';
      font-weight: 500;
      font-size: 16px;
      line-height: 150%;
      color: var(--blue-5);
      padding-top: 20px;

      &:hover {
        opacity: 0.8;
      }
    }
  }

  @media (max-width: 935px) {
    display: none;
  }
`;

export const SidebarAds = styled(Ad)`
  margin-top: 40px;
  display: block;
  width: 100%;

  img {
    width: 100%;
    height: auto;
  }

  @media (max-width: 935px) {
    display: none;
  }
`;

export const SidebarOtherPlatform = styled.div`
  margin-top: 40px;
  margin-bottom: 60px;

  .section-podcast-detail-content--sidebar-others-item {
    padding: 16px 0;
    display: flex;
    align-items: center;
    border-bottom: 1px solid var(--neutral-2);
    .section-podcast-detail-content--sidebar-others-item-img {
      width: 30px;
      margin-right: 16px;
    }
    .section-podcast-detail-content--sidebar-others-item-title {
      font-weight: 500;
      font-size: 16px;
      line-height: 150%;
      color: var(--black-color);
      margin: 0;
    }
  }
`;
